import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  class: "pt-3"
}

import { InsurancePolicy } from '@/interfaces';
import { replaceBookmark } from '@/utils/bookmark.replace';
import { formatDate } from 'date-fns';
import { IInsurancePolicyStatusRules } from '@/utils/self-service-rules/InsurancePolicyStatusRules';
import { SelfServiceService } from '@/services/store';
import { Discriminators } from '@/constants/insurance-policy-const';

enum Bookmarks {
  renewalStartDate = 'renewalStartDate',
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RenewalUpcomingLinks',
  props: {
    insurancePolicy: {},
    item: {},
    renewLink: {},
    policyStatusRules: {}
  },
  setup(__props: any) {

const props = __props;

const replaceBookmarks = (content: string) => {
  const renewalStartDate = props.insurancePolicy.renewalTermStart
    ? formatDate(props.insurancePolicy.renewalTermStart, 'dd MMMM yyyy').toString()
    : null;

  if (renewalStartDate) {
    content = replaceBookmark(Bookmarks.renewalStartDate, content, renewalStartDate);
  }

  //If no document replace this content.
  if (!props.insurancePolicy?.renewalDocumentId) {
    content = content.replace('View your', '');
  }

  return content;
};

const downloadDocument = async (documentId: string) => {
  if (!documentId) return;

  try {
    await SelfServiceService.getDownloadCoC(documentId);
  } catch (error) {
    console.error('error', error);
  }
};

const showRenewButton = () => {
  return props.policyStatusRules?.showPaymentDue && props.policyStatusRules?.autoRenewActuallyOff;
};

const showRenewalDocumentLink = () => {
  return (
    props.insurancePolicy?.renewalDocumentId !== undefined &&
    props.insurancePolicy?.currentTermPaymentDetails?.discriminator === Discriminators.NonResponsivePaymentDetails &&
    props.policyStatusRules?.autoRenewActuallyOff &&
    props.insurancePolicy?.currentRenewalPreference == false
  );
};

const renew_Click = () => {
  const url = props.renewLink.link.value.href + '?policyId=' + props.insurancePolicy.policyNumber;
  window.open(url, '_blank');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (replaceBookmarks(_ctx.item?.firstLinkCompanionContent?.value)?.length ?? 0 > 0)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "text-racq-dark-grey text-m pr-1",
          innerHTML: replaceBookmarks(_ctx.item?.firstLinkCompanionContent?.value)
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("span", null, [
      (showRenewalDocumentLink())
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (downloadDocument(_ctx.insurancePolicy?.renewalDocumentId))),
            class: "text-base inline cursor-pointer mb-2",
            innerHTML: replaceBookmarks(_ctx.item.firstLinkContent.value)
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    (showRenewButton())
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "!min-w-24 btn btn-sm btn-primary",
            "data-test-id": "actionButton",
            onClick: renew_Click
          }, _toDisplayString(props.renewLink?.link?.value?.text), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})